import { render, staticRenderFns } from "./SCrudFile.vue?vue&type=template&id=408d7f61&scoped=true"
import script from "./SCrudFile.vue?vue&type=script&lang=js"
export * from "./SCrudFile.vue?vue&type=script&lang=js"
import style0 from "./SCrudFile.vue?vue&type=style&index=0&id=408d7f61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408d7f61",
  null
  
)

export default component.exports